import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import styles from './AdminLayout.module.css';

interface TabGroup {
  label: string;
  tabs: { to: string; label: string }[];
}

const tabGroups: TabGroup[] = [
  {
    label: 'System',
    tabs: [
      { to: '/admin/customize', label: 'Anpassungen' },
      { to: '/admin/sso', label: 'SSO-Konfiguration' },
      { to: '/admin/ssl', label: 'SSL / Domain' },
      { to: '/admin/ai-settings', label: 'KI-Einstellungen' },
    ],
  },
  {
    label: 'Berechtigungen',
    tabs: [
      { to: '/admin/users', label: 'Benutzer' },
      { to: '/admin/modules', label: 'Module' },
    ],
  },
  {
    label: 'Stammdaten',
    tabs: [
      { to: '/admin/company', label: 'Firmendaten' },
      { to: '/admin/events', label: 'Events' },
    ],
  },
  {
    label: 'Externe Links',
    tabs: [
      { to: '/admin/external-links', label: 'Externe Links' },
    ],
  },
  {
    label: 'Feature Requests',
    tabs: [
      { to: '/admin/feature-requests', label: 'Feature Requests' },
    ],
  },
];

function getActiveGroup(pathname: string): string {
  for (const group of tabGroups) {
    if (group.tabs.some((tab) => pathname.startsWith(tab.to))) {
      return group.label;
    }
  }
  return tabGroups[0].label;
}

export function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeGroup = getActiveGroup(location.pathname);
  const activeGroupData = tabGroups.find((g) => g.label === activeGroup) ?? tabGroups[0];

  return (
    <div>
      {/* Header mit Zurück-Button und Tabs */}
      <div className={styles.header}>
        <div className={styles.headerTop}>
          <button
            className={styles.backButton}
            onClick={() => navigate('/')}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M10 12L6 8l4-4" />
            </svg>
            Zurück zum Dashboard
          </button>
          <h1 className={styles.title}>Administration</h1>
        </div>

        {/* Hauptreiter */}
        <nav className={styles.mainTabs}>
          {tabGroups.map((group) => (
            <button
              key={group.label}
              className={`${styles.mainTab} ${activeGroup === group.label ? styles.mainTabActive : ''}`}
              onClick={() => navigate(group.tabs[0].to)}
            >
              {group.label}
            </button>
          ))}
        </nav>

        {/* Sub-Tabs (nur anzeigen wenn mehr als 1 Tab) */}
        {activeGroupData.tabs.length > 1 && (
          <nav className={styles.tabs}>
            {activeGroupData.tabs.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                className={({ isActive }) =>
                  `${styles.tab} ${isActive ? styles.tabActive : ''}`
                }
              >
                {tab.label}
              </NavLink>
            ))}
          </nav>
        )}
      </div>

      {/* Content */}
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
}
